import * as React from "react"
import { SelectSeeker } from "ui-seeker/core"

import { ALERTS } from 'app/@common/constants'


export default function SelectAlertType({ ...props }) {

    const getDataTabSelected = (alertType, available=null) => {
        const data = {
            [ALERTS.TYPE.COMPETITION]: () => {
                return [
                    ...available?.includes(5) ? [{ label: ALERTS.RATES, value: '5' }] : [],
                    ...available?.includes(6) ? [{ label: ALERTS.AVAILABILITY, value: '6' }] : [],
                ]
            },
            [ALERTS.TYPE.PARITY_OTA]: () => {
                return [
                    ...available?.includes(2) ? [{ label: ALERTS.RATES, value: '2' }] : [],
                    ...available?.includes(4) ? [{ label: ALERTS.AVAILABILITY, value: '4' }] : [],
                ]
            },
            [ALERTS.TYPE.PARITY_META]: () => {
                return [
                    ...available?.includes(1) ? [{ label: ALERTS.RATES, value: '1' }] : [],
                    ...available?.includes(3) ? [{ label: ALERTS.AVAILABILITY, value: '3' }] : [],
                ]
            },
            [ALERTS.TYPE.PACKAGES]: () => {
                return [
                    ...available?.includes(7) ? [{ label: ALERTS.RATES, value: '7' }] : [],
                    ...available?.includes(8) ? [{ label: ALERTS.AVAILABILITY, value: '8' }] : [],
                ]
            },
            [ALERTS.TYPE.RATE_CONDITIONS]: () => {
                return [
                    { label: ALERTS.RATE_CONDITIONS, value: '9' }
                ]
            }
        }
        
        return data[alertType]()
    }

    const myProps = {
        placeholder: 'All alert types',
        firstSelect: false, isClearable: false, options: getDataTabSelected(props.tabAlertType || ALERTS.TYPE.COMPETITION, props.available),
        icon: { icon: 'keyboard' }, isMulti: false,
        ...props
    }

    return <SelectSeeker {...myProps} />
}